import Component from 'flarum/common/Component';
import ItemList from 'flarum/common/utils/ItemList';
import listItems from 'flarum/common/helpers/listItems';
import avatar from '../../../common/helpers/avatar';
import Link from 'flarum/common/components/Link';
export default class BlogAuthor extends Component {
  view() {
    const author = !this.attrs.loading ? this.attrs.article ? this.attrs.article.user() : this.attrs.user : null;
    return m("div", {
      className: 'FlarumBlog-Article-Author'
    }, m("div", {
      className: "FlarumBlog-Article-Author-background ".concat(this.attrs.loading ? 'FlarumBlog-Author-Ghost' : ''),
      style: {
        backgroundColor: author && author.color() ? author.color() : null
      }
    }), m("div", {
      className: 'FlarumBlog-Article-Author-Avatar'
    }, author ? m(Link, {
      href: app.route('user', {
        username: author.username()
      })
    }, avatar(author)) : m("span", {
      className: 'Avatar FlarumBlog-Author-Ghost'
    })), author && m("div", {
      className: 'FlarumBlog-Article-Author-Info'
    }, m(Link, {
      href: app.route('user', {
        username: author.username()
      }),
      className: 'FlarumBlog-Article-Author-Name'
    }, author.displayName()), m("p", {
      className: 'FlarumBlog-Article-Author-Bio'
    }, author.bio && author.bio()), m("ul", {
      className: 'FlarumBlog-Article-Author-Extended'
    }, listItems(this.items().toArray()))), this.attrs.loading && m("div", null, m("span", {
      className: 'FlarumBlog-Article-Author-Name FlarumBlog-Author-Ghost'
    }, "\xA0"), m("p", {
      className: 'FlarumBlog-Article-Author-Bio FlarumBlog-Author-Ghost'
    }, "\xA0"), m("p", {
      className: 'FlarumBlog-Article-Author-Bio FlarumBlog-Author-Ghost'
    }, "\xA0"), m("p", {
      className: 'FlarumBlog-Article-Author-Bio FlarumBlog-Author-Ghost'
    }, "\xA0")));
  }
  items() {
    return new ItemList();
  }
}
flarum.reg.add('v17development-blog', 'forum/components/BlogItemSidebar/BlogAuthor', BlogAuthor);